
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import LoadingComponent from '../../CommonUtils/components/LoadingComponent.vue';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { ScreenName } from '@/CommonUtils/fixed/ScreenName';
import { Constants } from '../../CommonUtils/fixed/Constants';
import axios from 'axios';
import router from '../../router';
// 2025/08/27 [No221申請受付年度非活性対応] morimoto add start
import { applicationFormModule } from '../../Uketsuke/store/modules/ApplicationForm';
// 2025/08/27 [No221申請受付年度非活性対応] morimoto add end
Vue.component('LoadingComponent', LoadingComponent);


@Component
export default class Cydeen2 extends Vue {

  private isOrderUser() {
    return supervisingModule.IS_ORDER_USER;
  }
  private isFirstLogin() {
    return supervisingModule.IS_FIRST_LOGIN;
  }
  private getUserInfo() {
    return supervisingModule.GET_USER_INFO.szkNm + '　' + supervisingModule.GET_USER_INFO.username;
  }

  private toUketsukeTop() {
    router.push({name: 'uketsukeMenu'});
  }

  private toUketsukeAcceptorTop() {
    // 2025/08/27 [No221申請受付年度非活性対応] morimoto add start
    applicationFormModule.moduleResetDetail();
    // 2025/08/27 [No221申請受付年度非活性対応] morimoto add end
    router.push({name: 'accepterMainMenu'});
  }

  private toMenu() {
    router.push({name: ScreenName.MENU});
  }

  private logout() {
    if (supervisingModule.IS_ORDER_USER) {
      // ユーザが発注者の時
      axios.post(Constants.KANRI_URL + '/logout')
           .then((response) => {
            // 成功
            router.push({name: ScreenName.LOGOUT});
          });
    } else {
      // ユーザが受注者の時
      axios.post(Constants.UKETSUKE_URL + '/logout')
           .then((response) => {
            // 成功
            router.push({name: ScreenName.LOGOUT});
          });
    }
  }
}
